<template>
  <div class="container orders-page">
    <v-head></v-head>
    <v-left current="orders" active="diy"></v-left>
    <div>
      <div class="filter-dic clearfix">
        <div class="fl">
          <el-input
            size="small"
            v-model="filter.keyword"
            placeholder="搜订单号、工厂单号、备注"
            clearable
            @clear="search"
            @change="search"
            style="width: 300px"
            class="w400 input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
          <el-date-picker
            size="small"
            style="width: 256px"
            v-model="filter.time_range"
            clearable
            @change="search"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </div>
      </div>
      <div>
        <div>
          <ul v-loading="loading" style="padding-bottom: 100px">
            <li
              class="create-li fl"
              style="width:200px;height:300px;"
              v-for="(item, index) in list_data.list"
              :key="index"
            >
              <el-image
                  style="width: 100%; max-height: 100%"
                  :src="item.file_oss"
                  :preview-src-list="[item.file_oss]"
                >
              </el-image>
              <p class="gray-color" style="position:absolute;left:0;bottom:0;color:black;">{{item.ctime}}</p>
            </li>
            <li style="clear: both"></li>
          </ul>
        </div>
        <el-pagination
          class="my-page"
          background
          :page-size="list_data.size"
          :page-sizes="[24, 30, 40, 50, 100]"
          layout="total, prev, pager, next"
          @current-change="changePage"
          :total="list_data.total"
        >
        </el-pagination>
      </div>
    </div>
    <component :is="popName" :row="edit_row"></component>
  </div>
</template>
<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
const pop_create_by_result = (resolve) => require(["@/pages/diy/templates/_pop_create_by_result"], resolve);
const pop_download_create = (resolve) => require(["@/pages/orders/create/_pop_download_create"], resolve);
export default {
  components: {
    "v-head": head,
    "v-left": left,
    pop_create_by_result,
    pop_download_create,
  },
  data() {
    return {
      loading: false,
      popName: null,
      edit_row: null,
      filter: {
        page: 1,
        size: 50,
        keyword: "",
        time_range:[],
      },
      list_data: {
        size: 50,
        page: 1,
        total: 0,
        list: [],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    changePage(e) {
      this.filter.page = e;
      this.getList();
    },
    search() {
      this.filter.page = 1;
      this.getList();
    },
    toCreate(row) {
      this.edit_row = row;
      this.popName = "pop_create_by_result";
    },
    toDownload(row) { 
      this.edit_row = row;
      this.popName = "pop_download_create";
    },
    getList() {
      this.loading = true;
      this.$http
        .post("/v1/pri/orders/get-upload-files", this.filter)
        .then((response) => {
          this.loading = false;
          var res = response.data;
          if (res.code == 1) {
            this.list_data = res.data;
          }
        });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped>
.orders-page .filter-dic {
  margin-bottom: 14px;
}
.create-li {
  margin: 10px 10px 0 0;
  position: relative;
  border: 1px solid #dfdfdf;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
}
.create-li .diy-dom {
  width: 156px;
  height: 310px;
  background-position: center center;
  background-size: 100% 100%;
  position: relative;
}
.create-li .diy-dom img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.create-li .el-icon-close {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 11;
  cursor: pointer;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/pages/orders/UploadFiles.vue